import * as React from "react";
const SvgUtensilsAndPlates = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M16.885 4.804a7.5 7.5 0 0 1 3.188-.227.75.75 0 0 0 .214-1.484 9 9 0 1 0 .059 17.806.75.75 0 0 0-.224-1.483 7.502 7.502 0 0 1-8.622-7.391 7.501 7.501 0 0 1 5.385-7.22ZM4.5 3.75a.75.75 0 0 0-1.5 0v3.977a3.251 3.251 0 0 0 2.5 3.163v9.36a.75.75 0 0 0 1.5 0v-9.36a3.251 3.251 0 0 0 2.5-3.163V3.75a.75.75 0 0 0-1.5 0v3.977a1.75 1.75 0 1 1-3.5 0V3.75Z"
      fill="currentColor"
    />
    <path
      d="M6.25 3a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 6.25 3ZM18.323 6.574a.75.75 0 0 1-.53.919 4.667 4.667 0 0 0-3.3 3.3.75.75 0 0 1-1.45-.388 6.166 6.166 0 0 1 4.361-4.36.75.75 0 0 1 .919.53Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgUtensilsAndPlates;
